import type { BudgetSuppApplyRecord } from '../types/budgetNote';

export function normalizeBudgetSuppApplyHistory(raw: unknown): BudgetSuppApplyRecord[] {
  if (!Array.isArray(raw)) return [];
  const out: BudgetSuppApplyRecord[] = [];
  for (const item of raw) {
    if (!item || typeof item !== 'object') continue;
    const r = item as Partial<BudgetSuppApplyRecord>;
    const round = Number(r.round);
    const before = Number(r.before);
    const after = Number(r.after);
    if (!Number.isFinite(round) || !Number.isFinite(before) || !Number.isFinite(after)) continue;
    out.push({
      round: Math.max(1, Math.round(round)),
      before,
      after,
      applied_at: typeof r.applied_at === 'string' ? r.applied_at : '',
    });
  }
  return out;
}

/** 전체 행 기록 중 가장 큰 차수 + 1 */
export function nextBudgetSuppApplyRound(rows: ReadonlyArray<{ supp_apply_history?: BudgetSuppApplyRecord[] }>): number {
  let max = 0;
  for (const row of rows) {
    for (const rec of row.supp_apply_history ?? []) {
      if (rec.round > max) max = rec.round;
    }
  }
  return max + 1;
}
